export default "__VITE_ASSET__CQgDztj4__"